/* Reveal on scroll */
(function () {
  const items = document.querySelectorAll('[data-flux-reveal]');
  if (!items.length) return;

  const io = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        e.target.classList.add('is-visible');
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.15 });

  items.forEach(el => {
    el.classList.add('flux-reveal');
    io.observe(el);
  });
})();

/* Header hide/show on scroll */
(function () {
  const header = document.querySelector('header.header');
  if (!header) return;

  let last = window.scrollY;
  const offset = 80;

  window.addEventListener('scroll', () => {
    const y = window.scrollY;

    header.classList.toggle('has-shadow', y > 10);

    if (y > last && y > offset) header.classList.add('is-hidden');
    else header.classList.remove('is-hidden');

    last = y;
  }, { passive: true });
})();

/* Footer accordion (mobile) */
(function () {
  const blocks = document.querySelectorAll('[data-flux-acc]');
  if (!blocks.length) return;

  blocks.forEach(btn => {
    btn.addEventListener('click', () => {
      btn.classList.toggle('is-open');
    });
  });
})();
